import Action from 'constants/action-types'
import {
  SET_SELECTED_ATTRIBUTE,
  TRIGGER_MANUAL_SEARCH,
} from 'constants/action-types'
import type { SearchUIState } from 'types/search/ui'

const initialState: SearchUIState = {
  selectedAttributeCode: null,
  manualSearchAt: null,
}

export default (
  state: SearchUIState = initialState,
  action: Action,
): SearchUIState => {
  switch (action.type) {
    case SET_SELECTED_ATTRIBUTE:
      return {
        ...state,
        selectedAttributeCode: action.payload,
      }

    case TRIGGER_MANUAL_SEARCH:
      return {
        ...state,
        manualSearchAt: action.payload,
      }

    default:
      return state
  }
}
